import React from 'react';
import PropTypes from 'prop-types';

import {Box, ButtonBase, Stack, Typography} from 'views/components';
import {translate} from 'views/module';

import {getChatConversationTitle, getLatestChatMessageText} from '../../communicationUtils';

import moment from 'moment';

const ChatConversationList = (props) => {
  const {
    selectedChatConversationRn,
    selectedParticipantRn,
    setSelectedChatConversationRn,
    sortedChatConversations,
  } = props;

  return (
    <Box
      role='region'
      aria-label={translate('case.Communication.Chat.Conversations')}
      tabIndex={0}
      sx={{
        'display': 'flex',
        'flexShrink': 0,
        'minWidth': 0,
        'gap': 1,
        'overflowX': 'scroll',
        'pb': 1,
        'scrollbarWidth': 'thin',
        'scrollbarColor': '#CFCFD4 #F4F4F6',
        '&::-webkit-scrollbar': {
          height: '8px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#F4F4F6',
          borderRadius: '999px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#CFCFD4',
          borderRadius: '999px',
        },
      }}
    >
      {
        sortedChatConversations.map((conversation) => {
          const isSelected = conversation.conversationRn === selectedChatConversationRn;
          const latestMessageCreatedAt = conversation.latestMessage?.createdAt;

          return (
            <ButtonBase
              key={conversation.conversationRn}
              aria-pressed={isSelected}
              onClick={() => setSelectedChatConversationRn(conversation.conversationRn)}
              sx={{
                'display': 'block',
                'flex': '0 0 220px',
                'textAlign': 'left',
                'border': '1px solid',
                'borderColor': isSelected ? '#EB7A58' : '#ECECF1',
                'borderRadius': '9px',
                'backgroundColor': isSelected ? '#FFF4EE' : '#FFFFFF',
                'p': '10px 13px',
                '&:hover': {
                  backgroundColor: isSelected ? '#FFF1EA' : '#F7F8FA',
                  borderColor: isSelected ? '#EB7A58' : '#DCDDE5',
                },
              }}
              type='button'
            >
              <Stack sx={{gap: 0.5}}>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 700,
                    color: '#050A14',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {getChatConversationTitle(conversation, selectedParticipantRn)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 400,
                    color: '#63708A',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {getLatestChatMessageText(conversation)}
                </Typography>
                {
                  latestMessageCreatedAt && (
                    <Typography
                      sx={{
                        fontSize: '11px',
                        fontWeight: 400,
                        color: '#9A9BAE',
                      }}
                    >
                      {moment(latestMessageCreatedAt).format('MMM D, h:mm A')}
                    </Typography>
                  )
                }
              </Stack>
            </ButtonBase>
          );
        })
      }
    </Box>
  );
};

ChatConversationList.propTypes = {
  selectedChatConversationRn: PropTypes.string,
  selectedParticipantRn: PropTypes.string,
  setSelectedChatConversationRn: PropTypes.func.isRequired,
  sortedChatConversations: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default React.memo(ChatConversationList);
